import React from "react";
import $ from 'jquery';
import Tools from './utils/Tools';
var strings = Tools.getStrings();

export default class Finalize extends React.Component {
    constructor(props) {
        super(props);
        $('.loadingContainerv2').show();
        
        var extras = window.WebApp.getCart().getData().extras;
        this.state = {
            menus:{prices:[],total:0},
            extrasInfo:{info:[],total:0,prices:[]},
            extras:extras,
            googleInited: false,
            addressLat:null,
            addressLng:null,
            promocode:"",
            street:"",
            door:"",
            floor:"",
            postal_code:"",
            city:"",
            nif:"",
            billing_address:"",
            billing_name: "",
            change:"",
            payment_method:"",
            validatingPromoTxt:"",
            promoClass:"",
            validatingPromo:"Validar",
            device:"desktop",
            totalWithDiscount:0,
            delivery_method: 1,
            profileMenuVisible:false,
            tax:"0",
            priceRulesDiscount: 0,
            totalDiscount: 0,
            schedules:{},
            schedule: {},
            currentSchedules:[],
            advanceTimes:{delivery:30,takeaway:10},
            methods: [],
            scheduleId: "",
            day: "",
            store: "",
            mbway_phone: "",
            locations: {
				casa: {
					label: "casa",
					latitudeDelta: 0.025,
					longitudeDelta: 0.025,
					latitude: 38.7222524,
					longitude: -9.1393366,
					street: "",
					door: "",
					city: "",
					postal_code: "",
                    country: "Portugal",
				},
				trabalho: null,
				outra: null
            },
            addressLabel: "casa",
            loading: true,
            storename:"",
            obs:"",
            order_obs:"",
            productOffers: [],
            samebilling: false,
            stores: [],
            ccInited: false,
            nextSchedule: null,
            noavailablesch: false,
            updating: false
        }

        this.handleCartChange = this.handleCartChange.bind(this);
        this.changeData = this.changeData.bind(this);
    }

    componentDidMount() {
        var component = this;
        window.WebApp.getAccount().getSession((result) => {
            if(result.expired) {
                window.location.href="/login";
            } else {
                let session = result.session;
                let tax = "0";
                session.delivery_method = session.delivery_method != null ? parseInt(session.delivery_method) : 1;
                session.store = session.store != null ? parseInt(session.store) : 1;
                let postal_code = "";
                if(result.zipcode !== undefined && result.zipcode !== null && session.delivery_method !== 2) {
                    tax = result.zipcode.tarifa;
                    postal_code = result.zipcode.zipcode;
                } else if(session.delivery_method === 2) {
                    window.WebApp.getInfo().getStores((sr) => {
                        for(var i = 0; i < sr.stores.length; i++) {
                            if(sr.stores[i].id === session.store) {
                                this.setState({
                                    storename: sr.stores[i].name 
                                });
                            }
                        }
                    });
                }
                this.setState({
                    store: session.store,
                    delivery_method: session.delivery_method,
                    tax: tax,
                    postal_code
                }, () => this.getSchedules());
    
                window.WebApp.getAccount().getProfile((result) => {
                    let user = result.user;
                    let billing_address = "";
                    let billing_name = "";
                    let nif = "";
                    var street = localStorage.getItem('savedaddress') === null ? "" : localStorage.getItem('savedaddress');
                    let floor = "";
                    let door = "";
                    let city = "";
                    let postal_code = this.state.postal_code;
                    let locations = this.state.locations;
                    if(user !== null && user.billingProfile.nif !== null) {
                        nif = user.billingProfile.nif;
                        if(user.billingProfile.billing_addresses[0] !== undefined && user.billingProfile.billing_addresses[0].address !== "") {
                            billing_address = user.billingProfile.billing_addresses[0].address;
                            billing_name = user.billingProfile.billing_addresses[0].country;
                        }
                    }
                    if(result.locations !== undefined) {
                        locations = result.locations;
                        let location = locations["casa"];
                        if(location !== null) {
                            street = location.street;
                            floor = location.floor;
                            door = location.door;
                            city = location.city;
                            postal_code = location.postal_code;
                        }
                    }
        
                    this.setState({
                        billing_address:billing_address,
                        billing_name: billing_name,
                        nif:nif,
                        locations,
                        street: street,
                        floor: floor,
                        door: door,
                        city: city,
                        postal_code: postal_code,
                        loading: false
                    }, () => $('.loadingContainerv2').hide());
                });
                window.WebApp.getInfo().getStores((result) => {
                    this.setState({
                        stores:result.stores,
                    });
                });
                window.WebApp.getCheckout().getPaymentMethods((result) => {
                    this.setState({
                        methods:result.methods
                    });
                });
            }
        });

        this.handleCartChange();
        window.WebApp.getFlux().setNotifyCart(this.handleCartChange);

        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));

        $(document).mouseup(function(e) {
            var container = $(".profile-menu");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.hide();
                component.state.profileMenuVisible = false;
            }
        });

        this.calcPrice();

        this.initGoogleAddresss();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.step === "ccpayment" && this.state.ccInited === false) {
            this.removeScript();
            this.addScript(this.state.checkoutId);
        }
    }

    addScript(id) {
        const script = document.createElement("script");

        script.src = "https://oppwa.com/v1/paymentWidgets.js?checkoutId="+id;
        script.async = true;

        document.body.appendChild(script);
        this.setState({
            ccInited: true
        });
    }

    removeScript() {
        var tags = document.getElementsByTagName('script');
        for (var i = tags.length; i >= 0; i--){
            if (tags[i] && tags[i].getAttribute('src') !== null && tags[i].getAttribute('src').indexOf('paymentWidgets') !== -1){
                tags[i].parentNode.removeChild(tags[i]);
                return true;
            }
        }
    }

    initGoogleAddresss() {
        var component = this;

        console.log("init google");
        component.state.googleInited = true;
        var input = document.getElementById('google-address');
        var autocomplete = new window.google.maps.places.Autocomplete(input);
        autocomplete.setComponentRestrictions({'country': ['pt']});

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();
            for (var i = 0; i < place.address_components.length; i++) {
                if (place.address_components[i].types !== undefined) {
                    if (place.address_components[i].types[0] === "locality") {
                        component.state.city = place.address_components[i].long_name;
                    }
                    if (place.address_components[i].types[0] === "route") {
                        component.state.street = place.address_components[i].long_name;
                    }
                    if (place.address_components[i].types[0] === "street_number") {
                        component.state.door = place.address_components[i].long_name;
                    }
                }
            }
            component.setState({
                addressLat:place.geometry.location.lat(),
                addressLng:place.geometry.location.lng()
            })
        });
    }

    componentWillUnmount() {
        window.WebApp.getFlux().unsetNotifyCart(this.handleCartChange);
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    updateDimensions() {
        if($(window).width() < 700 && this.state.device === 'desktop') {
            this.setState({
                device:'mobile'
            });
        } else {
            if($(window).width() >= 700 && this.state.device === 'mobile') {
                this.setState({
                    device:'desktop'
                });
            }
        }
    }

    setNextSch() {
        let found = false;
        let day = "1";
        if(this.state.day !== "") {
            day = this.state.day;
        }
        for(var i = 0; i < this.state.currentSchedules.length; i++) {
            let isDisabled = !this.state.currentSchedules[i].active;
            let lastSchedule = this.state.currentSchedules[i].readable.split("-")[0];
            let lastHour = lastSchedule.split(':')[0];
            let lastMinute = lastSchedule.split(':')[1];
            let d = new Date();
            let m = "";
            let h = "";
            if(this.state.delivery_method === 1) {
                d.setMinutes(d.getMinutes() + parseInt(this.state.advanceTimes.delivery)+5);
                h = d.getHours();
                m = d.getMinutes();
            }else{
                d.setMinutes(d.getMinutes() + parseInt(this.state.advanceTimes.takeaway)+5);
                m = d.getMinutes();
                h = d.getHours();
            }

            if(day === "1" && h > lastHour){
                isDisabled = true;
            }
            else {
                if(day === "1" && h == lastHour && m >= lastMinute){
                    isDisabled = true;
                }
            }
            if(!isDisabled) {
                found = true;
                this.setState({
                    nextSchedule: this.state.currentSchedules[i]
                });
                break;
            }
        }
        if(!found) {
            this.setState({
                nextSchedule: null,
                noavailablesch: true
            });
        }
    }

    handleCartChange() {
        this.setState({
            extras: window.WebApp.getCart().getData().extras
        });
        this.calcPrice();
    }

    logout() {
        window.WebApp.getAccount().logout(function(result){
            window.location.href = "/checkout/conta/validar";
        });
    }

    changeLabel(label) {
		if(label !== this.state.addressLabel) {
            let locations = this.state.locations;
            if(locations[this.state.addressLabel] === null) {
                locations[this.state.addressLabel] = {};
            }
            locations[this.state.addressLabel].street = this.state.street;
            locations[this.state.addressLabel].city = this.state.city;
            locations[this.state.addressLabel].door = this.state.door;
            locations[this.state.addressLabel].postal_code = this.state.postal_code;
            locations[this.state.addressLabel].floor = this.state.floor;
            if(this.state.locations[label] !== null) {
				let street = this.state.locations[label].street;
				let city = this.state.locations[label].city;
				let door = this.state.locations[label].door;
				let postal_code = this.state.locations[label].postal_code;
				let floor = "";
				if(this.state.locations[label].floor !== undefined && this.state.locations[label].floor !== null) {
					floor = this.state.locations[label].floor;
				}
				this.setState({
					street,
					city,
					door,
					postal_code,
                    floor,
                    locations
				});
			} else {
                this.setState({
					street: "",
					city: "",
					door: "",
					postal_code: "",
                    floor: "",
                    locations,
				});
            }
			this.setState({addressLabel:label});
		}
	}

    calcPrice() {
        window.WebApp.getNetwork().getLoading().doNotLoad(-1);
        var data = {order:window.WebApp.getCart().getData(), promocode:this.state.promocode};
        window.WebApp.getCheckout().calculatePriceWithPromo(data, (result) => {
            var total = result.menusInfo.total + result.extrasInfo.total;
            var totalWithDiscount = total;
            let totalDiscount = 0;
            if(result.metapromo !== null) {
                var metapromo = result.metapromo;
                if(metapromo.discount.type === 'fix') {
                    totalWithDiscount -= metapromo.discount.price;
                    totalDiscount = metapromo.discount.price;
                }else {
                    totalDiscount = total * metapromo.discount.price;
                    totalWithDiscount -= totalDiscount;
                }
                totalWithDiscount = (totalWithDiscount < 0 ? 0 : totalWithDiscount);
                // $('.discount').show();
                // $('.total').addClass('has-discount');
            }
            let priceRulesDiscount = result.menusInfo.priceRulesDiscount + result.extrasInfo.priceRulesDiscount;
            // totalDiscount += priceRulesDiscount;
            // totalWithDiscount -= priceRulesDiscount;
            if(result.tax === null || this.state.delivery_method === 2) {
                result.tax = 0;
            }
            let tax = result.tax;
            $('.quantity-btn').removeClass('progress');
            this.setState({
                menus:result.menusInfo,
                extrasInfo:result.extrasInfo,
                totalWithDiscount,
                priceRulesDiscount,
                totalDiscount,
                productOffers: result.productOffers,
                tax,
                updating: false
            });
        });
    }

    getSchedules(delivery_method, store) {
        if(delivery_method === undefined) {
            delivery_method = this.state.delivery_method;
        }
        if(store === undefined) {
            store = this.state.store;
        }
        window.WebApp.getCheckout().getSchedulesWithArgs(store, delivery_method, (result) => {
            this.setState({
                schedules: result.schedules,
                currentSchedules: result.schedules.today,
                advanceTimes: result.schedules.advanceTimes,
                schedule: result.schedules.today[0]
            }, () => {
                // this.setNextSch();
            });
        });
    }

    changeDay(day) {
        this.setState({
            day,
            scheduleId:"",
            currentSchedules: day === "1" ? this.state.schedules.today : this.state.schedules.tomorrow
        }, () => {
            // this.setNextSch();
        });
    }

    lessProduct(type, index) {
        if(!this.state.updating) {
            this.state.updating = true;
            $('.quantity-btn').addClass('progress');
            window.WebApp.getCart().removeOne(type, index, (() => {}));
        }
    }

    moreProduct(type, index) {
        if(!this.state.updating) {
            this.state.updating = true;
            $('.quantity-btn').addClass('progress');
            window.WebApp.getCart().addOne(type, index, (() => {}));
        }
    }

    changeData(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    changeSchedule(event) {
        let nextSchedule = null;
        for(var i = 0; i < this.state.currentSchedules.length; i++) {
            if(parseInt(this.state.currentSchedules[i].id) === parseInt(event.target.value)) {
                nextSchedule = this.state.currentSchedules[i];
            }
        }
        this.setState({
            [event.target.name]: event.target.value,
            nextSchedule,
        });
    }

    finalize() {
        let validated = true;
        let mbway_phone = this.state.mbway_phone;
        let scheduleId = this.state.scheduleId;

        if(this.state.payment_method === 5) {
            if(mbway_phone === "") {
                $('input[name="mbway_phone"]').addClass('error');
                validated = false;
                var elmnt = document.getElementById("methodbox");
                elmnt.scrollIntoView();
                return;
            }else {
                $('input[name="mbway_phone"]').removeClass('error');
            }
        }

        if(this.state.payment_method === "") {
            validated = false;
            $('.methodbox').addClass('error');
            var elmnt = document.getElementById("methodbox");
            elmnt.scrollIntoView();
            return;
        }else {
            $('.methodbox').removeClass('error');
        }

        if(this.state.day === "") {
            validated = false;
            $('select[name="day"]').addClass('error');
            var elmnt = document.getElementById("daybox");
            elmnt.scrollIntoView();
            return;
        }else {
            $('select[name="day"]').removeClass('error');
        }

        if(this.state.scheduleId === "" && this.state.nextSchedule === null) {
            validated = false;
            $('select[name="scheduleId"]').addClass('error');
            var elmnt = document.getElementById("daybox");
            elmnt.scrollIntoView();
            return;
        }else {
            $('select[name="scheduleId"]').removeClass('error');
        }

        let validatezip = false;
        let locations = this.state.locations;
        if(parseInt(this.state.delivery_method) === 1) {
            let locations = this.state.locations;
            if(locations[this.state.addressLabel] === null) {
                locations[this.state.addressLabel] = {};
            }
            locations[this.state.addressLabel].street = this.state.street;
            locations[this.state.addressLabel].city = this.state.city;
            locations[this.state.addressLabel].door = this.state.door;
            locations[this.state.addressLabel].postal_code = this.state.postal_code;
            locations[this.state.addressLabel].floor = this.state.floor;
            if(locations[this.state.addressLabel] === null || locations[this.state.addressLabel].street === "") {
                $('input[name="street"]').addClass('error');
                validated = false;
            } else {
                $('input[name="street"]').removeClass('error');
            }
            if(locations[this.state.addressLabel] === null || locations[this.state.addressLabel].door === "") {
                $('input[name="door"]').addClass('error');
                validated = false;
            } else {
                $('input[name="door"]').removeClass('error');
            }
            if(locations[this.state.addressLabel] === null || locations[this.state.addressLabel].city === "") {
                $('input[name="city"]').addClass('error');
                validated = false;
            } else {
                $('input[name="city"]').removeClass('error');
            }
            if(this.state.postal_code.length !== 8 || this.state.postal_code.indexOf('-') < 0 || locations[this.state.addressLabel] === null || locations[this.state.addressLabel].postal_code === "") {
                $('input[name="postal_code"]').addClass('error');
                validated = false;
            } else {
                $('input[name="postal_code"]').removeClass('error');
                validatezip = true;
            }
        }

        let store = this.state.store;
        if(validated) {
            if(validatezip) {
                window.WebApp.getCheckout().validateZipcode(this.state.postal_code, (result) => {
                    if(!result.invalidZip) {
                        store = result.zipcode.store_id;
                        $('.loadingContainerv2').show();
                        let billingAddress = this.state.billing_address;
                        if(this.state.nif !== "" && billingAddress === ""){
                            billingAddress = this.state.street;
                        }

                        let orderObs = this.state.order_obs;

                        if(scheduleId === "" && this.state.nextSchedule != null) {
                            scheduleId = this.state.nextSchedule.id;
                        }

                        var data = {order:window.WebApp.getCart().getData(), promocode:this.state.promocode,change:this.state.change,
                            payment_method:this.state.payment_method, addresses: locations,
                            profile_comments: this.state.obs, orderObs: orderObs,
                            addressLabel: this.state.addressLabel, profile:{nif:this.state.nif, obs:""},
                            billingAddress:{address:billingAddress, country:this.state.billing_name, postal_code:""},
                            addressLat: this.state.addressLat, addressLng:this.state.addressLng,
                            scheduleId: scheduleId, delivery_method:this.state.delivery_method,
                            day: this.state.day, store: store
                        };

                        if(mbway_phone !== "") {
                            data.mbway_phone = mbway_phone;
                        }

                        window.WebApp.getCheckout().finalize(data, (result) => {
                            if(result.checkoutId !== undefined && result.checkoutId !== null) {
                                $('.loadingContainerv2').hide();
                                this.setState({
                                    step: "ccpayment",
                                    checkoutId: result.checkoutId
                                });
                            }else {
                                window.WebApp.getCart().emptyCurrentOrder();
                                switch (this.state.payment_method) {
                                    case 5:
                                        window.location.href = "/sucesso-pagamento-com-mbway";
                                        break;
                                    case 7:
                                        window.location.href = "/sucesso-entidade-e-referencia";
                                        break;
                                    default:
                                        window.location.href = "/sucesso";
                                        break;
                                }
                            };
                        });
                    }else {
                        this.setState({
                            invalidzip: true
                        });
                        var elmnt = document.getElementById("addressbox");
                        elmnt.scrollIntoView();
                        return;
                    }
                });
            } else {
                $('.loadingContainerv2').show();
                let billingAddress = this.state.billing_address;
                if(this.state.nif !== "" && billingAddress === ""){
                    billingAddress = this.state.street;
                }

                let orderObs = this.state.order_obs;

                if(scheduleId === "" && this.state.nextSchedule != null) {
                    scheduleId = this.state.nextSchedule.id;
                }

                var data = {order:window.WebApp.getCart().getData(), promocode:this.state.promocode,change:this.state.change,
                    payment_method:this.state.payment_method, addresses: locations,
                    profile_comments: this.state.obs, orderObs: orderObs,
                    addressLabel: this.state.addressLabel, profile:{nif:this.state.nif, obs:""},
                    billingAddress:{address:billingAddress, country:this.state.billing_name, postal_code:""},
                    addressLat: this.state.addressLat, addressLng:this.state.addressLng,
                    scheduleId: scheduleId, delivery_method:this.state.delivery_method,
                    day: this.state.day, store: store
                };

                if(mbway_phone !== "") {
                    data.mbway_phone = mbway_phone;
                }

                window.WebApp.getCheckout().finalize(data, (result) => {
                    if(result.checkoutId !== undefined && result.checkoutId !== null) {
                        $('.loadingContainerv2').hide();
                        this.setState({
                            step: "ccpayment",
                            checkoutId: result.checkoutId
                        });
                    }else {
                        window.WebApp.getCart().emptyCurrentOrder();
                        switch (this.state.payment_method) {
                            case 5:
                                window.location.href = "/sucesso-pagamento-com-mbway";
                                break;
                            case 7:
                                window.location.href = "/sucesso-entidade-e-referencia";
                                break;
                            default:
                                window.location.href = "/sucesso";
                                break;
                        }
                    };
                });
            }
        } else {
            var elmnt = document.getElementById("addressbox");
            elmnt.scrollIntoView();
            return;
        }
    }

    validatePromocode() {
        if(!$('.promo-btn').hasClass('loading') && this.state.promocode !== "") {
            $('.promo-btn').addClass('loading');

            this.setState({
                validatingPromo:"A validar..."
            });
            window.WebApp.getNetwork().getLoading().doNotLoad(-1);
            window.WebApp.getCart().validatePromocode(this.state.promocode, (result) => {
                $('.promo-btn').removeClass('loading');
                if(result.valid && result.message === undefined) {
                    this.setState({
                        validatingPromoTxt:"Código válido!",
                        promoClass:"valid-promo",
                        validatingPromo:'Validar'
                    }, () => this.calcPrice());
                }else {
                    this.setState({
                        validatingPromoTxt:"Código inválido!",
                        promoClass:"invalid-promo",
                        validatingPromo:'Validar'
                    }, () => this.calcPrice());
                }
            });
        }
    }

    changePayment(payment_method) {
        this.setState({
            payment_method,
        });
    }

    setSameBilling() {
        if(!this.state.samebilling) {
            let address = this.state.street;
            if(this.state.door !== "") {
                address += " "+this.state.door;
            }
            if(this.state.postal_code !== "") {
                address += ", "+this.state.postal_code;
            }
            if(this.state.city !== "") {
                address += ", "+this.state.city;
            }
            this.setState({
                samebilling: true,
                billing_address: address
            });
        } else {
            this.setState({
                samebilling: false,
            });
        }
    }

    changeDelivery(delivery_method) {
        this.setState({
            delivery_method,
            scheduleId: "",
        }, () => {
            var data = {
                values:[
                    {key:'delivery_method',value:this.state.delivery_method},
                ]
            };
            window.WebApp.getAccount().saveSession(data, (result) => {
                this.calcPrice();
            });
        });
        this.getSchedules(delivery_method);
    }

    changeStore(store) {
        this.setState({
            store,
        });
        this.getSchedules(this.state.delivery_method, store);
    }

    render() {
        let tax = this.state.tax;
        if(this.state.delivery_method === 2) {
            tax = 0;
        }
        return (
            <div className="checkout-page main-container">
                {window.WebApp.getCart().isCartEmpty() &&
                    <div className="center-text">
                        <p style={{marginTop:"50px",fontSize:"18px"}}>{strings.cartempty}</p>
                        <a href="/loja"><button style={{marginTop:"30px", width: "200px"}}>{strings.backstore}</button></a>
                    </div>
                }
                {!window.WebApp.getCart().isCartEmpty() &&
                    <div className="flex between checkout-content" style={{textAlign:"left",alignItems:"flex-start"}}>
                        {this.state.step === "ccpayment" &&
                            <div className="left-side checkout-height">
                                <div className="box-wrap">
                                    <form action={window.location.protocol+"//"+window.location.hostname+"/api/v3/ccpayment/confirm"} className="paymentWidgets" data-brands="VISA MASTER"></form>
                                </div>
                            </div>
                        }
                        {this.state.step !== "ccpayment" &&
                            <div className="left-side checkout-height">
                                <h2>{strings.deliverydetails}</h2>
                                <div className="box-wrap">
                                    <h3 className="f700">Método de Entrega</h3>
                                    <h5 className="f600">Selecione o método</h5>
                                    <div className="flex start maxwidth">
                                        <button style={{maxWidth:"140px", marginRight:"10px", marginBottom:"10px", fontSize:"14px", fontWeight:"normal", textTransform: "capitalize", flex: 1}}
                                        className={(this.state.delivery_method !== 1 ? " grey-btn" : "")}
                                            onClick={() => this.changeDelivery(1)}>
                                            Home delivery
                                        </button>
                                        <button style={{maxWidth:"140px", marginRight:"10px", marginBottom:"10px", fontSize:"14px", fontWeight:"normal", textTransform: "capitalize", flex: 1}}
                                        className={(this.state.delivery_method !== 2 ? " grey-btn" : "")}
                                            onClick={() => this.changeDelivery(2)}>
                                            Take-away
                                        </button>
                                    </div>
                                    {this.state.delivery_method === 2 &&
                                        <div>
                                            <h5 className="f600">Selecionar loja</h5>
                                            <select name="store" value={this.state.store} onChange={(e) => this.changeStore(e.target.value)} style={{background:'url('+window.dropdown+') 0 0 no-repeat'}}>
                                                <option disabled value="">Selecione uma loja</option>
                                                {this.state.stores.map(function(store, index){
                                                    return (
                                                        <option key={index} value={store.id}>
                                                            {store.name}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    }
                                </div>
                                <div className="box-wrap" id="daybox">
                                    <h3 className="f700">{strings.deliverydate}</h3>
                                    <h5 className="f600">{strings.selectday}</h5>
                                    <select name="day" onChange={(e) => this.changeDay(e.target.value)} style={{background:'url('+window.dropdown+') 0 0 no-repeat'}} value={this.state.day}>
                                        <option value={""} disabled>{strings.selectoneday}</option>
                                        <option value={"1"}>Hoje</option>
                                        <option value={"2"}>Amanhã</option>
                                    </select>
                                    {this.state.day !== "" &&
                                        <div>
                                            <h5 className="f600">{strings.selecthour}</h5>
                                            <select name="scheduleId" id="scheduleId" onChange={(e) => this.changeSchedule(e)} style={{background:'url('+window.dropdown+') 0 0 no-repeat'}} value={this.state.scheduleId}>
                                                <option value={""} disabled>Selecione a hora</option>
                                                {this.state.currentSchedules.map((schedule, index) => {
                                                    var isDisabled = false;
                                                    var lastSchedule = schedule.readable.split("-")[0];
                                                    var lastHour = lastSchedule.split(':')[0];
                                                    var lastMinute = lastSchedule.split(':')[1];
                                                    var d = new Date();
                                                    var h = "";
                                                    var m = "";
                                                    if(this.state.delivery_method === 1) {
                                                        d.setMinutes(d.getMinutes() + parseInt(this.state.advanceTimes.delivery)+5);
                                                        h = d.getHours();
                                                        m = d.getMinutes();
                                                    }else{
                                                        d.setMinutes(d.getMinutes() + parseInt(this.state.advanceTimes.takeaway)+5);
                                                        m = d.getMinutes();
                                                        h = d.getHours();
                                                    }

                                                    if(this.state.day === "1" && h > lastHour){
                                                        isDisabled = true;
                                                    }
                                                    else {
                                                        if(this.state.day === "1" && h === lastHour && m >= lastMinute){
                                                            isDisabled = true;
                                                        }
                                                    }
                                                    return (
                                                        <option key={index} value={schedule.id} disabled={isDisabled || !schedule.active}>
                                                            {schedule.readable}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                            {this.state.nextSchedule !== null &&
                                                <p style={{fontSize: "20px", marginTop:"10px"}}><span className="green f700">{this.state.day === "1" ? "Hoje," : "Amanhã,"}</span> no horário de <span className="green f700">{this.state.nextSchedule.period === 1 ? "almoço" : "jantar"}</span> entre as <span className="green f700">{this.state.nextSchedule.readable.split("-")[0]}</span> e as <span className="green f700">{this.state.nextSchedule.readable.split("-")[1]}</span></p>
                                            }
                                            {this.state.noavailablesch && this.state.day === "1" &&
                                                <p style={{fontSize: "20px", marginTop:"10px"}}>Lamentamos, mas hoje já não existem horários disponíveis para entrega. Obrigado.</p>
                                            }
                                        </div>
                                    }
                                </div>
                                {this.state.delivery_method === 1 &&
                                    <div id="addressbox" className="box-wrap">
                                        <div>
                                            <h5 className="f600">{strings.address}</h5>
                                            <div className="flex start maxwidth">
                                                <button className={"address-label" + (this.state.addressLabel !== "casa" ? " grey-btn" : "")}
                                                onClick={() => this.changeLabel("casa")}>
                                                    {window.tipo === "btb" ? strings.home1 : strings.home}
                                                </button>
                                                <button className={"address-label" + (this.state.addressLabel !== "trabalho" ? " grey-btn" : "")}
                                                onClick={() => this.changeLabel("trabalho")}>
                                                    {window.tipo === "btb" ? strings.work1 : strings.work}
                                                </button>
                                                <button className={"address-label" + (this.state.addressLabel !== "outra" ? " grey-btn" : "")}
                                                onClick={() => this.changeLabel("outra")}>
                                                    {window.tipo === "btb" ? strings.other1 : strings.other}
                                                </button>
                                            </div>
                                            <form autoComplete="off" method="post">
                                                <div className="input-wrap">
                                                    <input id="google-address" key={3} type="text" onKeyUp={(e) => localStorage.setItem('savedaddress', e.target.value)}
                                                    placeholder={strings.address} name="street" value={this.state.street} onChange={this.changeData} disabled={window.tipo === "btb" ? true : false}/>
                                                </div>
                                                <div className="flex between">
                                                    <div className="input-wrap flex1">
                                                        <input placeholder={strings.zipcode} name="postal_code" type="text" maxLength="8"
                                                            value={this.state.postal_code} onChange={this.changeData} disabled={window.tipo === "btb" ? true : false}/>
                                                    </div>
                                                    <div className="input-wrap flex1">
                                                        <input placeholder={strings.zone} name="city" type="text"
                                                            value={this.state.city} onChange={this.changeData} disabled={window.tipo === "btb" ? true : false}/>
                                                    </div>
                                                </div>
                                                <div className="flex between">
                                                    <div className="input-wrap flex1">
                                                        <input placeholder={strings.number} name="door" type="text"
                                                            value={this.state.door} onChange={this.changeData} disabled={window.tipo === "btb" ? true : false}/>
                                                    </div>
                                                    <div className="input-wrap flex1">
                                                        <input placeholder={strings.floor} name="floor" type="text"
                                                            value={this.state.floor} onChange={this.changeData} disabled={window.tipo === "btb" ? true : false}/>
                                                    </div>
                                                </div>
                                                {true === false &&
                                                    <div className="input-wrap">
                                                        <input placeholder={strings.obs} name="obs" type="text" maxLength="150"
                                                            value={this.state.obs} onChange={this.changeData}/>
                                                    </div>
                                                }
                                                {this.state.invalidzip && <p style={{color:"red"}}>Lamentamos mas ainda não fazemos entregas no código postal introduzido!</p>}
                                            </form>
                                        </div>
                                    </div>
                                }
                                <div className="box-wrap">
                                    <h3 className="f700">{strings.billingData}</h3>
                                    <div className="flex start checkboxwrap">
                                        <div className="checkbox" onClick={() => this.setSameBilling()}>
                                            {this.state.samebilling &&
                                                <div></div>
                                            }
                                        </div>
                                        <p style={{marginBottom:"0px"}}>Morada de faturação igual à morada de entrega</p>
                                    </div>
                                    <div className="input-wrap">
                                        <input name="nif" type="text" placeholder={strings.nif}
                                            value={this.state.nif} onChange={this.changeData}/>
                                    </div>
                                    <div className="input-wrap">
                                        <input name="billing_name" type="text" placeholder={strings.name}
                                            value={this.state.billing_name} onChange={this.changeData}/>
                                    </div>
                                    {!this.state.samebilling &&
                                        <div className="input-wrap">
                                            <input name="billing_address" type="text" placeholder={strings.address}
                                                value={this.state.billing_address} onChange={this.changeData}/>
                                        </div>
                                    }
                                </div>
                                <div className="box-wrap">
                                    <h5 className="f600">{strings.promocode}</h5>
                                    <div className="input-wrap flex between">
                                        <input type="text" className="flex1" name="promocode" placeholder={strings.putpromo}
                                            value={this.state.promocode} onChange={this.changeData} onBlur={() => this.validatePromocode()}/>
                                        <button style={{width:"100px", paddingTop:"11px !important", paddingBottom:"11px !important", marginLeft:"10px"}}>
                                            Validar
                                        </button>
                                    </div>
                                    <p style={{marginTop:"5px"}} className={"promo-info " + this.state.promoClass}>{this.state.validatingPromoTxt}</p>
                                </div>
                                <div className="box-wrap methodbox" id="methodbox">
                                    <h5 className="f600">{strings.paymentmethod}</h5>
                                    <div className="flex start maxwidth">
                                        {this.state.methods.map((method, index) => {
                                            return (
                                                <button key={index} style={{maxWidth:"100px", marginRight:"10px", marginBottom:"10px", fontSize:"14px", fontWeight:"normal", textTransform: "capitalize", flex: 1}}
                                                className={(this.state.payment_method !== method.config_key ? " grey-btn" : "")}
                                                    onClick={() => this.changePayment(method.config_key)}>
                                                    {method.name}
                                                </button>
                                            )
                                        })}
                                    </div>
                                    {this.state.payment_method === 2 &&
                                        <div className="input-wrap">
                                            <input type="text" name="change" placeholder={strings.changefor}
                                                value={this.state.change} onChange={this.changeData}/>
                                        </div>
                                    }
                                    {this.state.payment_method === 5 &&
                                        <div className="input-wrap">
                                            <input name="mbway_phone" type="tel" placeholder={strings.mbwayphone}
                                                maxLength="9" value={this.state.mbway_phone} onChange={this.changeData}/>
                                        </div>
                                    }
                                </div>
                                <div className="box-wrap">
                                    <h5 className="f600">Observações</h5>
                                    <input type="text" name="order_obs" placeholder="Observações"
                                        value={this.state.order_obs} onChange={this.changeData}/>
                                </div>
                                {this.state.device === "mobile" &&
                                    <div className="cart-items">
                                        <h2 style={{flex:1}}>{strings.yourreq}</h2>
                                        {this.state.menus.prices.map((product, index) => {
                                            return (
                                                <div key={index}>
                                                    <div className="flex start" style={{alignItems:"flex-start"}}>
                                                        <p className="green"><b>{product.quantity}x</b></p>
                                                        <div style={{flex:1}}>
                                                            <p className="item-title">{product.name}</p>
                                                            {product.modifiers !== undefined &&
                                                                product.modifiers.map((mod, modIndex) => {
                                                                    if(mod.active) {
                                                                        return (
                                                                            <p style={{marginLeft:"10px"}} key={modIndex}>{mod.description}</p>
                                                                        )
                                                                    }
                                                                    return null;
                                                                })
                                                            }
                                                            {product.composition !== undefined &&
                                                                <p className="composition">
                                                                    {product.composition.products.map((comp, compIndex) => {
                                                                        return (
                                                                            <span key={compIndex}>{comp.name + (compIndex < product.composition.products.length - 1 ? ", " : "")}</span>
                                                                        )
                                                                    })}
                                                                </p>
                                                            }
                                                        </div>
                                                        <p className="item-price">{product.price.toFixed(2)}€</p>
                                                    </div>
                                                    <div className="flex between" style={{marginTop:"15px"}}>
                                                        <div className="flex between quantities">
                                                            <div className="quantity-btn minus" onClick={() => this.lessProduct("menu",index)}>
                                                                <img alt="menos" src={window.menos}/>
                                                            </div>
                                                            <div className="quantity-btn plus" onClick={() => this.moreProduct("menu",index)}>
                                                                <img alt="mais" src={window.mais}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {product.modifiers !== undefined &&
                                                        product.modifiers.map((mod, index2) => {
                                                            if(mod.active === "true") {
                                                                return (
                                                                    <p key={index2}>{mod.description}</p>
                                                                )
                                                            }
                                                            return null;
                                                        })
                                                    }
                                                </div>
                                            )
                                        })}
                                        {this.state.extras.map((product, index) => {
                                            if(product.quantity > 0) {
                                                var price = product.price.toFixed(2);
                                                if(this.state.extrasInfo.info[product.id] !== undefined){
                                                    price = parseFloat(this.state.extrasInfo.info[product.id].price).toFixed(2);
                                                }
                                                return (
                                                    <div key={index} style={{marginBottom:"10px"}}>
                                                        <div className="flex start">
                                                            <p className="green"><b>{product.quantity}x</b></p>
                                                            <div style={{flex:1}}>
                                                                <p className="item-title">{product.name}</p>
                                                            </div>
                                                            <p className="item-price">{price}€</p>
                                                        </div>
                                                        {product.composition !== undefined &&
                                                            <p className="composition">
                                                                {product.composition.products.map((comp, compIndex) => {
                                                                    return (
                                                                        <span key={compIndex}>{comp.name + (compIndex < product.composition.products.length - 1 ? ", " : "")}</span>
                                                                    )
                                                                })}
                                                            </p>
                                                        }
                                                        <div className="flex between quantities">
                                                            <img alt="menos" className="quantity-btn" src={window.menos} onClick={() => this.lessProduct("extra", index)}/>
                                                            <img alt="mais" className="quantity-btn" src={window.mais} onClick={() => this.moreProduct("extra", index)}/>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            return null;
                                        })}
                                        {this.state.productOffers.map((offer, index) => {
                                            return (
                                                <div key={index} style={{marginBottom:"10px"}}>
                                                    <p style={{marginTop:"20px", marginBottom: "5px"}}><b>{strings.offers}:</b></p>
                                                    <div className="flex start">
                                                        <p className="green"><b>{offer.quantity}x</b></p>
                                                        <div style={{flex:1}}>
                                                            <p className="item-title">{offer.name}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <hr style={{width:"100%",borderTop:"1px solid #CCC"}}/>
                                        {this.state.tax !== null && this.state.tax !== undefined && this.state.delivery_method === 1 &&
                                            <div className="flex between" style={{marginBottom:"0px", marginTop:"10px"}}>
                                                <p className="flex1">{strings.deltax}</p>
                                                <p>{parseFloat(this.state.tax).toFixed(2)}€</p>
                                            </div>
                                        }
                                        <div className="flex btween" style={{marginBottom:"0px"}}>
                                            <p className="flex1 f700" style={{fontSize:"20px"}}>{strings.total}</p>
                                            <p className="green" style={this.state.totalDiscount > 0 ? {textDecoration:"line-through"} : {}}>{(this.state.menus.total + this.state.extrasInfo.total + parseFloat(this.state.tax)).toFixed(2)}€</p>
                                        </div>
                                        {this.state.priceRulesDiscount > 0 && true === false &&
                                            <div className="flex btween" style={{marginBottom:"0px", marginTop:"10px"}}>
                                                <p className="flex1 f700" style={{fontSize:"20px"}}>Poupou:</p>
                                                <p className="green">{this.state.priceRulesDiscount.toFixed(2)}€</p>
                                            </div>
                                        }
                                        {this.state.totalDiscount > 0 &&
                                            <div className="flex btween" style={{marginBottom:"0px", marginTop:"10px"}}>
                                                <p className="flex1 f700" style={{fontSize:"20px"}}>{strings.tdisc}</p>
                                                <p className="green">{this.state.totalWithDiscount.toFixed(2)}€</p>
                                            </div>
                                        }
                                        <h5 style={{maxWidth:"210px"}}><a href="/loja" className="green underline">{strings.moreprods}</a></h5>
                                        {((this.state.menus.total + this.state.extrasInfo.total >= 5) || this.state.delivery_method === 2) &&
                                            <button style={{padding: "10px", margin: "20px auto 0px auto", width: "calc(100% - 24px)"}}
                                            onClick={() => this.finalize()}>{strings.finalize1}</button>
                                        }
                                        {(this.state.menus.total + this.state.extrasInfo.total < 5) && this.state.delivery_method === 1 &&
                                            <p style={{color:"#FFF",fontSize:"16px",marginTop:"20px"}}><b>{strings.mintotal}</b></p>
                                        }
                                    </div>
                                }
                            </div>
                        }
                            {this.state.device === 'desktop' &&
                                <div className="right-side checkout-height" style={{paddingBottom: "50px"}}>
                                    <h2 style={{flex:1}}>{strings.yourreq}</h2>
                                    <div className="cart-items">
                                        {this.state.menus.prices.map((product, index) => {
                                            return (
                                                <div key={index}>
                                                    <div className="flex start" style={{alignItems:"flex-start"}}>
                                                        <p className="green"><b>{product.quantity}x</b></p>
                                                        <div style={{flex:1}}>
                                                            <p className="item-title">{product.name}</p>
                                                            {product.modifiers !== undefined &&
                                                                product.modifiers.map((mod, modIndex) => {
                                                                    if(mod.active) {
                                                                        return (
                                                                            <p style={{marginLeft:"10px"}} key={modIndex}>{mod.description}</p>
                                                                        )
                                                                    }
                                                                    return null;
                                                                })
                                                            }
                                                            {product.composition !== undefined &&
                                                                <p className="composition">
                                                                    {product.composition.products.map((comp, compIndex) => {
                                                                        return (
                                                                            <span key={compIndex}>{comp.name + (compIndex < product.composition.products.length - 1 ? ", " : "")}</span>
                                                                        )
                                                                    })}
                                                                </p>
                                                            }
                                                        </div>
                                                        <p className="item-price">{product.price.toFixed(2)}€</p>
                                                    </div>
                                                    <div className="flex between quantities">
                                                        <img alt="menos" className="quantity-btn" src={window.menos} onClick={() => this.lessProduct("menu", index)}/>
                                                        <img alt="mais" className="quantity-btn" src={window.mais} onClick={() => this.moreProduct("menu", index)}/>
                                                    </div>
                                                    {product.modifiers !== undefined &&
                                                        product.modifiers.map((mod, index2) => {
                                                            if(mod.active === "true") {
                                                                return (
                                                                    <p key={index2}>{mod.description}</p>
                                                                )
                                                            }
                                                            return null;
                                                        })
                                                    }
                                                </div>
                                            )
                                        })}
                                        {this.state.extras.map((product, index) => {
                                            if(product.quantity > 0) {
                                                return (
                                                    <div key={index} style={{marginBottom:"10px"}}>
                                                        <div className="flex start">
                                                            <p className="green"><b>{product.quantity}x</b></p>
                                                            <div style={{flex:1}}>
                                                                <p className="item-title">{product.name}</p>
                                                            </div>
                                                            <p className="item-price">{product.price.toFixed(2)}€</p>
                                                        </div>
                                                        {product.composition !== undefined &&
                                                            <p className="composition">
                                                                {product.composition.products.map((comp, compIndex) => {
                                                                    return (
                                                                        <span key={compIndex}>{comp.name + (compIndex < product.composition.products.length - 1 ? ", " : "")}</span>
                                                                    )
                                                                })}
                                                            </p>
                                                        }
                                                        <div className="flex between quantities">
                                                            <img alt="menos" className="quantity-btn" src={window.menos} onClick={() => this.lessProduct("extra", index)}/>
                                                            <img alt="mais" className="quantity-btn" src={window.mais} onClick={() => this.moreProduct("extra", index)}/>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            return null;
                                        })}
                                        {this.state.productOffers.map((offer, index) => {
                                            return (
                                                <div key={index} style={{marginBottom:"10px"}}>
                                                    <p style={{marginTop:"20px", marginBottom: "5px"}}><b>{strings.offers}:</b></p>
                                                    <div className="flex start">
                                                        <p className="green"><b>{offer.quantity}x</b></p>
                                                        <div style={{flex:1}}>
                                                            <p className="item-title">{offer.name}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <hr style={{width:"100%",borderTop:"1px solid #CCC"}}/>
                                        {this.state.tax !== "0" && this.state.tax !== null && this.state.tax !== undefined && this.state.delivery_method === 1 &&
                                            <div className="flex between" style={{marginBottom:"0px", marginTop:"10px"}}>
                                                <p className="flex1">{strings.deltax}</p>
                                                <p>{parseFloat(this.state.tax).toFixed(2)}€</p>
                                            </div>
                                        }
                                        <div className="flex btween" style={{marginBottom:"0px"}}>
                                            <p className="flex1 f700" style={{fontSize:"20px"}}>{strings.total}</p>
                                            <p className="green" style={this.state.totalDiscount > 0 ? {textDecoration:"line-through"} : {}}>{(this.state.menus.total + this.state.extrasInfo.total + parseFloat(this.state.tax)).toFixed(2)}€</p>
                                        </div>
                                        {this.state.priceRulesDiscount > 0 && true === false &&
                                            <div className="flex btween" style={{marginBottom:"0px", marginTop:"10px"}}>
                                                <p className="flex1 f700" style={{fontSize:"20px"}}>Poupou:</p>
                                                <p className="green">{this.state.priceRulesDiscount.toFixed(2)}€</p>
                                            </div>
                                        }
                                        {this.state.totalDiscount > 0 &&
                                            <div className="flex btween" style={{marginBottom:"0px", marginTop:"10px"}}>
                                                <p className="flex1 f700" style={{fontSize:"20px"}}>{strings.tdisc}</p>
                                                <p className="green">{this.state.totalWithDiscount.toFixed(2)}€</p>
                                            </div>
                                        }
                                        <h5 style={{maxWidth:"210px"}}><a href="/loja" className="green underline">{strings.moreprods}</a></h5>
                                        {((this.state.menus.total + this.state.extrasInfo.total >= 5) || this.state.delivery_method === 2) &&
                                            <button style={{padding: "10px", margin: "20px auto 0px auto", width: "calc(100% - 24px)"}}
                                            onClick={() => this.finalize()}>{strings.finalize1}</button>
                                        }
                                        {(this.state.menus.total + this.state.extrasInfo.total < 5) && this.state.delivery_method === 1 &&
                                            <p className="green" style={{fontSize:"16px",marginTop:"20px"}}><b>{strings.mintotal}</b></p>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            );
        }
    }
